const UpdateStatusIcon = () => {
    return (<i className="fas fa-sync-alt"></i>);
};

export default UpdateStatusIcon;